import Vue from 'vue'
import Router from 'vue-router'

import adminCrearUsuario from './views/HomeAdmin/CrearUsuario.vue';
import Seguimiento from './views/HomeAdmin/Seguimiento.vue';
import Perfiles from './views/HomeAdmin/Perfiles.vue';
import Cargos from './views/HomeAdmin/Cargos.vue';
import SolicitudPermiso from './views/HomeEndUser/SolicitudPermiso.vue';
import Historico from './views/HomeEndUser/Historico.vue';
import Motivopermiso from './views/HomeAdmin/Motivopermiso.vue';
import PermisosEncurso from './views/HomeAdmin/PermisosEnCurso.vue';
import HomeSuperadmin from './views/HomeSuperAdmin/HomeSuperadmin.vue';
import Sedes from './views/HomeAdmin/Sedes.vue';
import HistoricoDomicilios from './views/HomeAdmin/HistoricoDomicilios.vue';
import Password from './views/HomeAdmin/Password.vue';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
      
      //******************THE WHOLE MENU FOR SUPERADMINUSER************ */

      {
        path: "/homesuperadmin",
        name: "HomeSuperadmin",
        component: HomeSuperadmin,
        meta: { requiresAuthsuperadmin: true }
      },


      //******************THE WHOLE MENU FOR SUPERADMINUSER************ */
  


      //******************THE WHOLE MENU FOR ADMINUSER************ */
      /*{
        path: "/homeadmin",
        name: "homeadmin",
        component: HomeAdmin,
        meta: { requiresAuthadmin: true }
      },*/

      {
        path: "/admin/changepassword",
        name: "changePassword",
        component: Password,
        meta: { requiresAuthadmin: true }
      },
      {
        path: "/admin/sedes",
        name: "crearSedes",
        component: Sedes,
        meta: { requiresAuthadmin: true }
      },
      {
        path: "/admin/crearusuario",
        name: "crearUsuario",
        component: adminCrearUsuario,
        meta: { requiresAuthadmin: true }
      },

      {
        path: "/admin/seguimiento",
        name: "Seguimiento",
        component: Seguimiento,
        meta: { requiresAuthadmin: true }
      },

      {
        path: "/admin/perfiles",
        name: "Perfiles",
        component: Perfiles,
        meta: { requiresAuthadmin: true }
      },

      {
        path: "/admin/cargos",
        name: "Cargos",
        component: Cargos,
        meta: { requiresAuthadmin: true }
      },


      {
        path: "/admin/motivopermiso",
        name: "Motivopermiso",
        component: Motivopermiso,
        meta: { requiresAuthadmin: true }
      },
      {
        path: "/admin/permisosencurso",
        name: "PermisosEncurso",
        component: PermisosEncurso,
        meta: { requiresAuthadmin: true }
      },
      {
        path: "/admin/historicodomicilios",
        name: "HistoricoDomicilios",
        component: HistoricoDomicilios,
        meta: { requiresAuthadmin: true }
      },


      //******************THE WHOLE MENU FOR ADMINUSER************ */



      //******************THE WHOLE MENU FOR ENDUSER************ */

      /*{
        path: "/homenduser",
        name: "HomeEndUser",
        component: HomeEndUser,
        meta: { requiresAuthenduser: true }
      },*/

      {
        path: "/enduser/solicitud",
        name: "solicitud",
        component: SolicitudPermiso,
        meta: { requiresAuthenduser: true }
      },

      {
        path: "/enduser/historico",
        name: "historico",
        component: Historico,
        meta: { requiresAuthenduser: true }
      },
      
       //******************THE WHOLE MENU FOR ENDUSER************ */

      {
        path: '*',
        meta: { requiresAuthsuperadmin: true }
      }

  ]
})


router.beforeEach((to, from, next) => {

  let endUser = true;
  let admin = true;
  let superadmin = true;
  let redirectPath = "";
  let anyuser=true;

  let todos = JSON.parse(localStorage.getItem("todos"));
  if (todos != null) {

    todos.roles.map((item) => {
      if (item.role_id == 1) {
        endUser = false;
        redirectPath = "/enduser/solicitud";
      }
      if (item.role_id == 2) {
        admin = false;
        redirectPath = "/admin/crearusuario";
      }
      if (item.role_id == 3) {
        superadmin = false;
        redirectPath = "/homesuperadmin";
      }
    })

  }else{
    anyuser = false;
    redirectPath = "/";
  }




  if (to.matched.some(record => record.meta.requiresAuthenduser)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.

    if (endUser) {
      console.log('WE HAVE GOT HERE...enduser');
      next({
        path: redirectPath,
        //query: { redirect: to.fullPath }
      })
    } else {
      next()
    }

  } else {
    next() // make sure to always call next()!
  }

  if (to.matched.some(record => record.meta.requiresAuthadmin)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.

    if (admin) {
      console.log('WE HAVE GOT HERE...admin');
      next({
        path: redirectPath,
        //query: { redirect: to.fullPath }
      })
    } else {
      next()
    }

  } else {
    next() // make sure to always call next()!
  }

  if (to.matched.some(record => record.meta.requiresAuthsuperadmin)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.

    if (superadmin) {
      console.log('WE HAVE GOT HERE...superadmin');
      next({
        path: redirectPath,
        //query: { redirect: to.fullPath }
      })
    } else {
      next()
    }

  } else {
    next() // make sure to always call next()!
  }

  if (to.matched.some(record => record.meta.requiresAuthsuperadmin)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.

    if (anyuser) {
      console.log('WE HAVE GOT HERE...anyuser...'+redirectPath);
      next({
        path: redirectPath,
        //query: { redirect: to.fullPath }
      })
    } else {
      next()
    }

  } else {
    next() // make sure to always call next()!
  }


})


export default router;